import { ID } from '@datorama/akita';
import { CommonFunctions } from '../static/common-functions';
import { AppClaims } from "./AppClaims";

export type Claim = { type: string, value: string; };

export class UsersBus {
    constructor(data: UsersBus = null) {
        if (data != null) {
            Object.assign(this, data);
        } else {
            this.appClaims = new AppClaims();
        }
    }
    id: ID;
    username: string;
    pass: string;
    isactive: boolean;
    userid: any;
    clientid: any;
    defaultDispatchViewId: any;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    forcePasswordReset: boolean;
    isAuthenticated: boolean;
    errorMessage: string;
    /**
    * @deprecated This property is deprecated and will be removed in future versions.
    */
    token: string;
    tokenDecoded: any;
    companyId: any;
    personId: any;
    poApprLimit: number = 0;
    vehicleId: any;
    appClaims: AppClaims;
    defaultDashboardLayoutId: any;
    applicationCode: string;
    birthday: Date;
    claims: Claim[];
    public hasRole(role: keyof AppClaims): boolean {
        if (this.appClaims) {
            let value = this.appClaims[role];
            if (typeof value === "boolean") {
                return value;
            }
        }
        if (this.claims) {
            let claim = this.claims.find(c => c.type === role);
            if (claim) {
                return claim.value === "1";
            }
        }

        return false;
    }
    setAppClaims(claims: any = null) {
        if (!this.appClaims) {
            this.appClaims = new AppClaims();
        }
        this.appClaims.setClaims(claims);
    }

    get isBirthday(): Boolean {
        if (!this.birthday) { return false; }
        var today = new Date(CommonFunctions.getDateNow().toDateString());
        var bd = new Date(this.birthday);
        return (today.getDate() == bd.getDate() && today.getMonth() == bd.getMonth());
    }

    get isZuggitUser(): boolean {
        return this.username?.toLowerCase().includes("zuggit");
    }

    get getDomainEnum(): number {
        const username = this.username?.toLowerCase();
        if (username?.includes("climatepros")) {
            return 0;
        }
        if (username?.includes("zuggit")) {
            return 1;
        }
        return -1;
    }
}
